import React, { useEffect, useState } from 'react';

import ContactAddressEdit from '@components/shared/contact_addresses/ContactAddressEdit';

import { contactAddressService } from '@services/admin/contactAddressService';
import { salesChannelService } from '@services/admin/salesChannelService';

interface SalesChannel {
  id: string;
  name: string;
  [key: string]: unknown;
}

const AdminContactAddressEdit: React.FC = () => {
  // admin scope 永遠單一 merchant（session 鎖定），無跨 merchant 切換問題，
  // wrapper 直接打 salesChannelService.list 取一次即可。
  const [salesChannels, setSalesChannels] = useState<SalesChannel[]>([]);

  useEffect(() => {
    (async () => {
      try {
        const data = await salesChannelService.list({});
        if (data?.success && Array.isArray(data.data)) {
          setSalesChannels(data.data as SalesChannel[]);
        }
      } catch (error) {
        console.error('Failed to load sales channels:', error);
      }
    })();
  }, []);

  return (
    <ContactAddressEdit
      contactAddressService={contactAddressService}
      role="admin"
      salesChannels={salesChannels}
    />
  );
};

export default AdminContactAddressEdit;
